import React, { useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { apolloZindexDialog, apolloZindexDialogOverlay } from "@nexthink/apollo-tokens";
export const StyledOverlay = styled.div.withConfig({ displayName: "StyledOverlay_APC-7311-productShell", componentId: "sc-1re7eca" })({
    zIndex: apolloZindexDialog,
    // we don't want the popper to inherit 'textAlign: center' from the container
    textAlign: "left",
});
export const GlobalStyledContextMenuBody = createGlobalStyle(({ paddingRight }) => ({
    body: {
        overflow: "hidden !important",
        paddingRight: `${paddingRight} !important`,
    },
}));
export const StyledContextMenuOverlay = styled.div.withConfig({ displayName: "StyledContextMenuOverlay_APC-7311-productShell", componentId: "sc-1ark84x" })({
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    zIndex: apolloZindexDialogOverlay,
});
export const ContextMenuOverlay = ({ children }) => {
    // if the body has a vertical scroll, we measure it and pass a padding-right to replace the scroll
    // because with overflow=hidden the scrollbar disappears (and the page width would increase and the content would shift).
    // it should not happen in product-shell anyway because it never allows a scrollbar in the body.
    const scrollBarCompensation = useRef(window.innerWidth - document.body.offsetWidth);
    const originalPaddingRight = useRef(window.getComputedStyle(document.body).paddingRight || "0px");
    // forces the triggering of `handleClickOutsidePortal`
    const closeOnRightClick = (e) => {
        e.preventDefault();
        e.currentTarget.click();
    };
    return (React.createElement(StyledContextMenuOverlay, { onContextMenu: closeOnRightClick, role: "presentation" },
        React.createElement(GlobalStyledContextMenuBody, { paddingRight: `calc(${originalPaddingRight.current} + ${scrollBarCompensation.current}px)` }),
        children));
};
//# sourceMappingURL=withPortal.style.js.map